/**
 * 路由配置
 */
import Vue from 'vue';
import NProgress from 'nprogress';
import VueRouter from 'vue-router';
import { WHITE_LIST, REDIRECT_PATH, LAYOUT_PATH, HOME_PATH } from '@/config/setting';
import store from '@/store';
import { getToken, setToken } from '@/utils/token-util';
import { routes, getMenuRoutes } from './routes';

Vue.use(VueRouter);

const ADMIN_HOME_PATH = HOME_PATH || '/xingzheng/dashboard';

function getSafeLoginTarget(path) {
  const target = Array.isArray(path) ? path[0] : path;
  if (!target || target === LAYOUT_PATH || target === '/login' || target === '/login-success' || target === '/sso/callback') {
    return ADMIN_HOME_PATH;
  }
  return target === '/xingzheng' || String(target).startsWith('/xingzheng/') ? target : ADMIN_HOME_PATH;
}

const router = new VueRouter({
  routes,
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { y: 0 };
  }
});

/**
 * 路由守卫
 */
router.beforeEach((to, from, next) => {
  if (!from.path.includes(REDIRECT_PATH)) {
    NProgress.start();
  }
  const isXingzhengRoute = to.path === '/xingzheng' || to.path.startsWith('/xingzheng/');
  const queryToken = to.query.token || to.query.access_token;
  const routeToken = Array.isArray(queryToken) ? queryToken[0] : queryToken;
  if (routeToken) {
    setToken(routeToken, true);
    const query = { ...to.query };
    delete query.token;
    delete query.access_token;
    const tokenLandingPaths = ['/login', '/login-success', '/sso/callback'];
    const redirectPath = tokenLandingPaths.includes(to.path) ? getSafeLoginTarget(query.from) : to.path;
    delete query.from;
    next({ path: redirectPath, query, replace: true });
    return;
  }
  if (to.query.sso_token && to.path !== '/login') {
    const query = { sso_token: to.query.sso_token };
    if (to.path !== LAYOUT_PATH) {
      query.from = to.path;
    }
    next({ path: '/login', query, replace: true });
    return;
  }
  // 判断是否登录
  if (getToken()) {
    if (to.path === LAYOUT_PATH || to.path === '/login-success') {
      next({ path: ADMIN_HOME_PATH, replace: true });
      return;
    }
    if (isXingzhengRoute) {
      if (!store.state.user.menus) {
        store.dispatch('user/fetchUserInfo').catch((e) => console.error(e));
      }
      next();
      return;
    }
    // 还未注册动态路由则先获取
    if (!store.state.user.menus) {
      store
        .dispatch('user/fetchUserInfo')
        .then(({ menus, homePath }) => {
          if (menus) {
            router.addRoute(getMenuRoutes(menus, homePath));
          }
          next({ ...to, replace: true });
        })
        .catch((e) => {
          console.error(e);
          next();
        });
    } else {
      next();
    }
  } else if (WHITE_LIST.includes(to.path)) {
    next();
  } else {
    next({
      path: '/login',
      query: to.path === LAYOUT_PATH ? {} : { from: to.path }
    });
  }
});

router.afterEach((to) => {
  if (!to.path.includes(REDIRECT_PATH) && NProgress.isStarted()) {
    setTimeout(() => {
      NProgress.done(true);
    }, 200);
  }
});

export default router;
